export default "__VITE_ASSET__bxGo7VuY__"